import React from 'react'
import { Text } from '@chakra-ui/react'

const Contact = () => {
  return (
    <div>
    <Text fontSize={"5xl"} m="3">
        Let's Talk!
    </Text>
    <Text fontSize={"3xl"} m="3">
        email me at <b>tzou@olin.edu</b>. I'll be in touch.
    </Text>
    </div>
  )
}

export default Contact
